// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sales-page-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.sales-page-title svg {
  width: 30px;
  height: 30px;
  color: #39783d;
}

.sales-tile {
  --sales-accent: #2563eb;
  --sales-accent-soft: #eff6ff;
  position: relative;
  overflow: hidden;
}

.sales-tile::before {
  position: absolute;
  inset: 0 0 auto;
  height: 3px;
  background: var(--sales-accent);
  content: '';
  opacity: 0;
  transition: opacity 0.2s ease;
}

.sales-tile:hover {
  border-color: var(--sales-accent);
}

.sales-tile:hover::before {
  opacity: 1;
}

.sales-tile .sales-tile-icon {
  display: grid;
  width: 72px;
  height: 72px;
  margin-bottom: 20px;
  border-radius: 20px;
  background: var(--sales-accent-soft);
  color: var(--sales-accent);
  place-items: center;
  transition: transform 0.2s ease;
}

.sales-tile:hover .sales-tile-icon {
  transform: scale(1.06);
}

.sales-tile-icon svg {
  width: 36px;
  height: 36px;
}

.sales-tile--green {
  --sales-accent: #15803d;
  --sales-accent-soft: #f0fdf4;
}

.sales-tile--violet {
  --sales-accent: #7c3aed;
  --sales-accent-soft: #f5f3ff;
}

.sales-tile--amber {
  --sales-accent: #b45309;
  --sales-accent-soft: #fffbeb;
}
`, "",{"version":3,"sources":["webpack://./src/pages/css/Sales.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,+BAA+B;EAC/B,WAAW;EACX,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,0BAA0B;EAC1B,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B","sourcesContent":[".sales-page-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.sales-page-title svg {\n  width: 30px;\n  height: 30px;\n  color: #39783d;\n}\n\n.sales-tile {\n  --sales-accent: #2563eb;\n  --sales-accent-soft: #eff6ff;\n  position: relative;\n  overflow: hidden;\n}\n\n.sales-tile::before {\n  position: absolute;\n  inset: 0 0 auto;\n  height: 3px;\n  background: var(--sales-accent);\n  content: '';\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.sales-tile:hover {\n  border-color: var(--sales-accent);\n}\n\n.sales-tile:hover::before {\n  opacity: 1;\n}\n\n.sales-tile .sales-tile-icon {\n  display: grid;\n  width: 72px;\n  height: 72px;\n  margin-bottom: 20px;\n  border-radius: 20px;\n  background: var(--sales-accent-soft);\n  color: var(--sales-accent);\n  place-items: center;\n  transition: transform 0.2s ease;\n}\n\n.sales-tile:hover .sales-tile-icon {\n  transform: scale(1.06);\n}\n\n.sales-tile-icon svg {\n  width: 36px;\n  height: 36px;\n}\n\n.sales-tile--green {\n  --sales-accent: #15803d;\n  --sales-accent-soft: #f0fdf4;\n}\n\n.sales-tile--violet {\n  --sales-accent: #7c3aed;\n  --sales-accent-soft: #f5f3ff;\n}\n\n.sales-tile--amber {\n  --sales-accent: #b45309;\n  --sales-accent-soft: #fffbeb;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
